import React from 'react';

const WindowsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="70"
            height="70"
            viewBox="0 0 2499.6 2500"
        >
            <path
                fill="#00adef"
                d="M1187.9 1187.9H0V0h1187.9zm1311.7 0h-1188V0h1187.9v1187.9zM1187.9 2500H0V1312.1h1187.9zm1311.7 0h-1188V1312.1h1187.9V2500z"
            ></path>
        </svg>
    );
};

export default WindowsIcon;